import React from 'react';
import QRCode from 'react-qr-code';

const PrintQRCode = ({ bulletin, etablissement, isGlobalPrint = false }) => {
  // Créer une chaîne d'informations clés pour le QR code en format texte lisible
  const createQRData = () => {
    if (!bulletin) return '';
    
    const lines = [
      `ÉTUDIANT: ${bulletin.etudiant?.nom || ''} ${bulletin.etudiant?.prenom || ''}`,
      `MATRICULE: ${bulletin.etudiant?.matricule || ''}`,
      `CLASSE: ${bulletin.classe?.libelle || ''}`,
      `NIVEAU: ${bulletin.classe?.niveau?.libelle || ''}`,
      `SEMESTRE: ${bulletin.semestre?.libelle || ''}`,
      `ANNÉE: ${bulletin.annee_academique?.libelle || ''}`,
      `ÉTABLISSEMENT: ${etablissement?.nom || ''}`,
      `DATE: ${bulletin.date_generation ? new Date(bulletin.date_generation).toLocaleDateString('fr-FR') : ''}`,
      `MOYENNE: ${bulletin.moyenne_semestre?.moyenne_generale ? bulletin.moyenne_semestre.moyenne_generale.toFixed(2) + '/20' : 'N/A'}`
    ];
    
    return lines.join('\n');
  };

  const qrData = createQRData();

  // Styles différents selon le contexte d'impression
  const containerStyle = isGlobalPrint ? {
    // Pour l'impression globale : positionnement fixe en bas à droite
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    width: '60px',
    height: '60px',
    zIndex: 1000,
    pageBreakInside: 'avoid',
    breakInside: 'avoid'
  } : {
    // Pour l'impression individuelle : positionnement absolu
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    pageBreakInside: 'avoid'
  };

  return (
    <div style={containerStyle}>
      <QRCode 
        value={qrData}
        size={60}
        level="M"
        style={{ 
          display: 'block'
        }}
      />
    </div>
  );
};

export default PrintQRCode;
